import { useSelector } from 'react-redux'

import { getPatient } from '~/store/reducers/patients'
import { getClientId, getPatientId } from '~/store/reducers/soap'

import { SoapHeaderMenuButton } from '../../soap-menu/SoapHeaderMenuButton'
import PatientDetailsHeader from '../../summary/patient-details/PatientDetailsHeader'

export const SoapPatientTile = () => {
  const clientId = useSelector(getClientId) ?? ''
  const patientId = useSelector(getPatientId) ?? ''
  const patient = useSelector(getPatient(patientId))

  return (
    <PatientDetailsHeader
      actionsSlot={<SoapHeaderMenuButton />}
      clientId={clientId}
      patient={patient}
    />
  )
}
